import * as React from 'react'
import { SVGProps } from 'react'
const SvgChangeAddress = (props: SVGProps<SVGSVGElement>) => (
  <svg width={7} height={13} viewBox="0 0 7 13" fill="none" {...props}>
    <path
      d="m4.455 12.552-.671-.63 1.326-1.224H1.114c-.31 0-.572-.1-.79-.301A.96.96 0 0 1 0 9.667V4.068l.955.885v4.678a.17.17 0 0 0 .055.13.199.199 0 0 0 .14.051h3.954L3.79 8.59l.665-.63 2.478 2.296-2.478 2.296ZM7 8.488l-.955-.884V2.92a.17.17 0 0 0-.055-.13.199.199 0 0 0-.14-.052H1.896L3.21 3.962l-.665.63L.067 2.296 2.545 0l.671.63L1.89 1.854h3.996c.31 0 .572.1.79.3A.96.96 0 0 1 7 2.887v5.602Z"
      fill="#000"
    />
  </svg>
)
export default SvgChangeAddress
